// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title {
  color: var(--foreground);
}

.color-div {
  position: absolute;
  z-index: 10;
  margin-top: 0.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/pages/management/labelManagement/detectionLabel/styles/popup.scss","webpack://./src/pages/management/labelManagement/detectionLabel/styles/popup.css"],"names":[],"mappings":"AACA;EACE,wBAAA;ACAF;;ADGA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;ACAF","sourcesContent":["\n.modal-title {\n  color: var(--foreground);\n}\n\n.color-div {\n  position: absolute;\n  z-index: 10;\n  margin-top: 0.5rem;\n}",".modal-title {\n  color: var(--foreground);\n}\n\n.color-div {\n  position: absolute;\n  z-index: 10;\n  margin-top: 0.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
